<script lang="ts" setup>
const { getJobTitleAttributes } = useApiAttributes()
const { t } = useI18n()
const api = useApi()

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/job-titles/enrich',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.name'),
    example: '/job-titles/enrich?name=chief%20executive%20officer',
    name: 'name',
    required: true,
    type: 'string',
  },
]

const responseAttributes: ApiAttribute[] = getJobTitleAttributes()

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}

const { data: response, execute, status } = useAsyncData(
  'doc:job-titles-enrich-from-name',
  () => api.jobTitles.enrich({ name: 'chief executive officer' }),
  { immediate: false },
)
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :loading="status === 'pending'"
    :query-attributes="queryAttributes"
    :response="response?.data"
    :response-attributes="responseAttributes"
    @visibility-change="onVisibilityChange"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "name": "The job title's name."
    }
  },
  "es": {
    "attributes": {
      "name": "El nombre de la profesión."
    }
  },
  "fr": {
    "attributes": {
      "name": "Le nom de la profession."
    }
  }
}
</i18n>
